import { ProgressBar, PROGRESSBAR_VALIDATION } from "../../../components/progressbar/ProgressBar";
import { forEach } from "jszip";
import { useMemo } from "react";


export const LISITopProgressBars = ({ criteria }) => {

  const BAR_SPACE_HEIGHT = 70;

  const [isAnalyzing, indicatorValue] = useMemo(() => {
    let isAnalyzing = false;
    let value = 0;
    criteria.forEach((criterion) => {
      if (criterion.value > criterion.threshold)
        value += criterion.weight;
      if (criterion.value > 0)
        isAnalyzing = true;
    });
    return [isAnalyzing, value];
  }, [criteria]);

  return (
    <div className="bg-gray-200 flex flex-col gap-8 border-4 rounded-md p-4">
      <style>{`
        @keyframes blinkBorder {
          0%, 100% { border-color: transparent; }
          50% { border-color: transparent; }
        }
        .blink-border {
          animation: blinkBorder 0.25s ease-in-out infinite;
        }
      `}</style>

      <h1 className="text-3xl text-center font-semibold">Analyse de l'IA</h1>

      <div className="relative text-2xl" style={{ height: BAR_SPACE_HEIGHT * criteria?.length}}>
        {
          [...criteria].sort((c1, c2) => c2.value - c1.value).map((criterion, criterionIndex) => {
            const top = criterionIndex * BAR_SPACE_HEIGHT;

            return (
              <div
                key={criterion.name}
                className="absolute w-full transition-all duration-500 ease-in-out"
                style={{ top: `${top}px`, height: BAR_SPACE_HEIGHT }}
              >
                {criterion.name}
                <ProgressBar value={criterion.value} height="h-8" bgColor="white" color={PROGRESSBAR_VALIDATION} />
              </div>
            );
          })
        }
      </div>

      {/*<div className="pb-4 text-5xl flex flex-col items-center justify-center text-center">*/}
      {/*  <div className="text-2xl">Niveau de confiance :</div>*/}

      {/*  {!isAnalyzing ?*/}
      {/*    <div>Aucune analyse en cours</div>*/}
      {/*    : indicatorValue >= 5 ?*/}
      {/*      <div className="text-success">Bon</div>*/}
      {/*      : indicatorValue >= 3 ?*/}
      {/*        <div className="text-yellow-500">Moyen</div>*/}
      {/*        :*/}
      {/*        <div className="text-error">Mauvais</div>*/}
      {/*  }*/}
      {/*</div>*/}

    </div>
  );
};